import axios from "axios";
import { baseUrl } from "../../constants/constants";

export const axiosV4 = axios.create({
  baseURL: `${baseUrl}/v4`,
  headers: {
    Authorization: `Bearer ${localStorage.getItem("amoozeshMeliToken")?.length ?? ""}`,
  },
});

axiosV4.interceptors.response.use(
  (res) => res,
  async (err) => {
    if (err.response && err?.response.status === 401) {
      if (Boolean(localStorage.getItem("amoozeshMeliToken")) === false) {
        localStorage.removeItem("amoozeshMeliToken");
        return;
      }

      console.log("Logging Out ....");

      try {
        localStorage.removeItem("amoozeshMeliToken");
        axiosV4.get("/user/logout");
      } catch (err) {
      } finally {
        window.location.reload();
      }
    }

    return Promise.reject(err);
  }
);
